import React, { useState } from "react";
import MaterialesExtra from "./MaterialesExtra";

export default function Entrena() {
    const temario = [
        {
            id: "Nivel 1",
            temario: [
                "Instalación de un IDE, uso de herramientas para debugging, declaración e inicialización de variables, tipos de variables, typecasting, I/O y operadores aritméticos",
                "Condicionales y bucles",
                "Listas y ordenamiento",
                "Funciones",
                "Búsqueda dicotómica",
                "Estructuras de datos de la STL",
                "Recursión",
                "Problemas de concurso"
            ]
        },
        {
            id: "Nivel 2",
            temario: [
                "Divide y vencerás; búsqueda dicotómica, ternaria y bisección",
                "Búsqueda completa (backtracking)",
                "Programación dinámica",
                "Problemas con ordenamiento y algoritmos voraces",
                "Estructuras de datos de la STL",
                "Grafos 1- exploración: búsqueda en anchura (BFS), búsqueda en profundidad (DFS) y sus aplicaciones",
                "Árboles y conjuntos distintos",
                "Grafos 2- caminos más cortos: Dijkstra y Floyd-Warshall"
            ]
        },
        {
            id: "Nivel 3",
            temario: [
                "Repaso grafos (BFS, DFS, Dijkstra, ordenamiento topológico, articulaciones, Bellman Ford); cómo resolver problemas avanzados sobre grafos y árboles (partido en dos clases)",
                "Programación dinámica: repaso del nivel 2 y técnicas avanzadas como máscaras de bits",
                "Problemas interactivos y output-only",
                "Problemas voraces y problemas con base matemática",
                "Geometría computacional",
                "Árboles de segmentos",
                "Programación dinámica 2 y/o árboles de segmentos 2, en función de las necesidades de las alumnas"
            ]
        },
        {
            id: "Nivel 4",
            temario: [
                "Clase 1: amortized analysis y los engranajes de C++",
                "Repaso 1: programación dinámica (clásicos y grafos)",
                "Clase 2: problemas interactivos y output-only",
                "Repaso 2: programación dinámica con máscaras de bits",
                "Clase 3: square root decomposition, geometría computacional y sweep line",
                "Repaso 3: programación dinámica sobre árboles",
                "Clase 4: problemas matemáticos y meet-in-the-middle",
                "Repaso 4: árboles",
                "Clase 5: BSTs, Heaps, Treaps y Tries",
                "Repaso 5: exploración de grafos",
                "Clase 6: aplicaciones de DFS: Euler paths, biconectividad y teoría de juego",
                "Repaso 6: árboles de segmentos",
                "Clase 7: árboles: binary lifting, HLD, centroid decomposition",
                "Repaso 7: árboles de Fenwick",
                "Clase 8: árboles de segmentos avanzados",
                "Repaso 8: monotonic stack"
            ]
        }
    ]

    const [nivelSeleccionado, setNivelSeleccionado] = useState("all");

    return (
        <div>
            <div className="destacado">
                <h1>Temario</h1>
                En esta sección presentamos el temario de la sexta edición de la OIFem desde nivel de introducción (nivel 1) hasta nivel avanzado (nivel 4). Además proponemos 
                material extra que es muy interesante para prepararse para el concurso!
            </div>
            
            <div className="sticky">
                <div>
                    <label htmlFor="nivel">Nivel:</label>
                    <select id="nivel"
                        value={nivelSeleccionado}
                        onChange={(e) => setNivelSeleccionado(e.target.value)}
                    >
                        {temario.map((nivel) => (
                            <option value={nivel.id}>{nivel.id}</option>
                        ))}
                        <option value="materiales-extra">Materiales Extra</option>
                        <option value="all">Todos</option>
                    </select>
                </div>
            </div>

            <div>
                {temario.map((nivel) => 
                    (nivelSeleccionado === nivel.id || nivelSeleccionado === "all") &&
                    <div>
                        <h2 className="sticky-edition-header sticky">{nivel.id}</h2>
                        {nivel.temario.map((t) =>
                            <p>{t}</p>
                        )}
                    </div> 
                )}
                
                {(nivelSeleccionado === "materiales-extra" || nivelSeleccionado === "all") && <MaterialesExtra/>}
            </div>
        </div>
    );
}
